import React, { Component } from 'react';
import { TableHead, TableRow, TableCell, Table, TableBody, Card, Box } from '@material-ui/core';
import { blueGrey, deepPurple } from '@material-ui/core/colors';

class DevisTableTitle extends Component {
    state = {  }
    render() {
        const { title, color } = this.props;
        return (
            <div className={(color ? color : "bgm-bluegray ") + "  p-5"}>
                <h4 className="text-center c-white"><i>{title}</i></h4>
            </div>
            
        );
    }
}
export class DevisTableTh extends Component {
    state = {  }
    render() {
        const { ttc, children } = this.props;
        return (
           
            <TableHead>
                {children}
                <TableRow>
                    <TableCell style={{textAlign: "center", minWidth:'300px'}} >Description</TableCell>
                    <TableCell style={{ textAlign: "center"}} >Quantité</TableCell>
                    <TableCell style={{ textAlign: "center"}} >Prix Unitaire</TableCell>
                    <TableCell style={{ textAlign: "center"}} >Total HT</TableCell>
                    <TableCell style={{ textAlign: "center"}} colSpan={2} >TVA {!ttc && "(Taux %)" }</TableCell>
                    {ttc && <TableCell style={{ textAlign: "center"}} >Total TTC</TableCell>}
                </TableRow>
            </TableHead>
                    
        );
    }
}
export class DevisTableThTotal extends Component {
    state = {  }
    render() {
        const { ttc, children } = this.props;
        return (
           
            <TableHead>
                {children}
                <TableRow>
                    <TableCell style={{ textAlign: "center"}} style={{minWidth:'300px'}} colSpan={3}></TableCell>
                    <TableCell style={{ textAlign: "center"}} >Total HT</TableCell>
                    <TableCell style={{ textAlign: "center"}} colSpan={2}>TVA</TableCell>
                    {ttc && <TableCell style={{ textAlign: "center"}} >Total TTC</TableCell>}
                </TableRow>
            </TableHead>
                    
        );
    }
}
class DevisTableLayout extends Component {
    state = {  }
    render() {
        const { title, children, ttc, color, total } = this.props;
        return (
            <Box p={1}>
                <Card >
                    <DevisTableTitle title={title} color={color} />
                    
                    <div className="table-responsive" style={{overflowX: "visible"}}>
                        <Table className="table table-striped table-bordered">
                            {total ? (

                                <DevisTableThTotal ttc={ttc} />
                            ) : (

                                <DevisTableTh ttc={ttc} />
                            )}
                            <TableBody>
                                
                            {children}
                            </TableBody>
                        </Table>
                    </div>
                </Card>

            </Box>
        );
    }
}


export default DevisTableLayout;